<template>
  <div>
    <div class="more">
      <div class="more_info">
        <div class="license_info">
          <h2><router-link to="/about">关于检验网</router-link></h2>
          <p>
            <a TARGET="_blank" href="https://beian.miit.gov.cn/"
              >COPYRIGHT(©)2017 - 2027 检验网 沪ICP备18009205号-3</a
            >
          </p>
          <p class="license_detail">
            <a
              TARGET="_blank"
              href="https://pic.jianyanwang.com/20241008/%E4%BA%92%E8%81%94%E7%BD%91%E8%8D%AF%E5%93%81%E4%BF%A1%E6%81%AF%E8%AF%81%E7%94%B5%E5%AD%90%E7%89%88%E6%9C%AC-%E6%96%B0-%E6%AD%A3%E6%9C%AC-%E5%8A%A0%E5%AD%97_small.png"
              >互联网药品信息服务资格证(沪)-经营性-2024-0271</a
            >&nbsp;
            <a
              TARGET="_blank"
              href="https://pic.jianyanwang.com/upload/20200203/4d52275f4b134a72bfec3153048e1916.pdf"
              >增值电信业务许可证</a
            >&nbsp;
            <a>服务热线:400 6057 800</a>
            <a>平台投诉电话:021-34680601-8004</a>
          </p>
          <p>
            <a
              target="_blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502007583"
              ><img src="../assets/icon.png" />沪公网安备 31011502007583号</a
            >
          </p>
        </div>
        <ul class="more_info_list">
          <li class="title">关注公众号</li>
          <li class="img">
            <img src="../assets/subscription.jpg" alt="检验网公众号" />
          </li>
        </ul>
        <!--<ul class="more_info_list">-->
        <!--<li class="title">微信小程序</li>-->
        <!--<li class="img"><img src="../assets/small_procedure.jpg" alt="检验网微信小程序"></li>-->
        <!--</ul>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>
<style scoped>
.more {
  width: 100%;
  float: left;
  background-color: #f5f5f5;
  padding: 10px 0 20px 0;
}
.more_info {
  width: 70%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.more_info_list {
  width: 12.5%;
  float: left;
  text-align: center;
}
.more_info_list li {
  font-size: 12px;
  width: 100%;
  color: #888888;
  padding: 5px 0;
}
.more_info_list li.title {
  font-size: 14px;
  font-weight: bold;
  color: #b6b6b6;
  padding: 10px 0;
}
.more_info_list img {
  width: 100px;
  height: 100px;
}
.license_info {
  width: 65%;
  float: left;
  text-align: left;
  margin-top: 20px;
}
.license_info p,
.license_info h2 {
  font-size: 12px;
  color: #b6b6b6;
  padding: 10px 0;
}
.license_info img {
  padding-right: 5px;
}
.license_detail a {
  padding-right: 5px;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .more_info,
  .license_info {
    width: 90%;
    text-align: center;
    margin-top: 0;
  }
  .more_info_list {
    width: 70%;
  }
  .more_info_list li {
    float: left;
  }
  .more_info_list li.title {
    width: 100%;
  }
  .more_info_list li.img {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue